// extracted by mini-css-extract-plugin
export default {"overlayWrapper":"UserProfile_overlayWrapper__nl3oB","viewBox":"UserProfile_viewBox__Vbolm"};